import { Banner, Text, TextLink } from 'tusk-ui'
import { useEffect, useState } from 'react'
import content from 'content/global/en/banner/content'
import { withGlobalContent } from 'mammoth/pages/PageContent'

const bannerClosedSessionKey = 'mmth-banner-public-closed'

type Props = {
    content: typeof content
}

function NavigationBanner({ content }: Props) {
    const [showBanner, setShowBanner] = useState(false)
    const { badge, message, link } = content

    useEffect(() => {
        const isBannerClosed = sessionStorage.getItem(bannerClosedSessionKey)

        if (isBannerClosed === 'true') {
            setShowBanner(false)
        } else {
            setShowBanner(true)
        }
    }, [])

    function close() {
        sessionStorage.setItem(bannerClosedSessionKey, 'true')
        setShowBanner(false)
    }

    if (!showBanner) {
        return null
    }

    return (
        <Banner.Root className='h-56 items-center justify-between'>
            <Banner.Badge className='mobile:hidden'>
                <Text className='rounded-lg bg-snow px-12 py-4 uppercase text-night'>{badge}</Text>
            </Banner.Badge>
            <Banner.Content className='flex'>
                <Text variant='l3' className='mobile:hidden'>
                    {message}
                </Text>
                <>
                    <TextLink to={link.href} variant='l3' linkVariant='underline' className='hidden mobile:block'>
                        {message}
                    </TextLink>
                    <TextLink to={link.href} variant='l3' linkVariant='underline' className='ml-8 mobile:hidden'>
                        {link.text}
                    </TextLink>
                </>
            </Banner.Content>
            <Banner.Close
                className='mobile:ml-auto'
                onClick={() => {
                    close()
                }}
            />
        </Banner.Root>
    )
}

export default withGlobalContent('banner', NavigationBanner)
